<div class="card card-wider card-cascade mb-3 force-page-break">
    <div class="view gradient-card-header primary-gradient white-text">
        <h3 class='h3-responsive text-center'>{{AssessmentResult?.assessment.name}}</h3>
    </div>
    <div class="card-body assessment-overview">
        <div class="page-block-center">
            <h3 class="ml-0 pl-0 h3-responsive" *ngIf="AssessmentResult?.assessment.creator">{{AssessmentResult?.assessment.creator}}</h3>
            <h6 class="h6-responsive" *ngIf="AssessmentResult?.assessment.creatorUrl">{{AssessmentResult?.assessment.creatorUrl}}</h6>
            <div [innerHTML]="AssessmentResult?.assessment.description"></div>
        </div>
    </div>
</div>
<div class="card card-wider card-cascade" *ngIf="IsSingleScaleResult">
    <div class="view gradient-card-header primary-gradient white-text">
        <h3 class='h3-responsive text-center'>Results</h3>
    </div>
    <div class="card-body assessment-scale-result single-scale">
        <div class="row justify-content-center text-center">
            <h4 class='col-8 h4-responsive'>YOUR CATEGORY:
                <span class='scale-name'>{{SingleScaleResult.range?.displayName}}</span>
            </h4>
        </div>
        <div class="row justify-content-center text-center" *ngIf="!SkipGraph">
            <app-scale-chart class="col-8" [scale-result]="SingleScaleResult" [show-scale-name]="false"></app-scale-chart>
            
        </div>
        <div class="row" *ngIf="!SkipContent">
            <div class="col" *ngIf="SingleScaleResult?.range?.clientContent" [innerHTML]="SingleScaleResult?.range?.clientContent"></div>
        </div>
        <div class="row" *ngIf="!SkipTable">
                <app-scale-questions-list  class="col-12" [Questions]="AssessmentResult.assessment.getQuestionsForScale(SingleScaleResult.scale)"></app-scale-questions-list>
        </div>
    </div>
</div>
<div class="card card-wider card-cascade" *ngIf="!IsSingleScaleResult">
    <div class="view gradient-card-header primary-gradient white-text">
        <h3 class='h3-responsive text-center'>Results</h3>
    </div>
    <div class="card-body assessment-scale-result no-gutter" >
        <div *ngFor="let scaleResult of ScaleResults;index as index;">
            <div [ngClass]="{'d-print-block':showPageHeader(index), 'd-none': !showPageHeader(index)}" 
                class="scalePageHeader view gradient-card-header primary-gradient white-text mt-2">
                <h3 class='h3-responsive text-center'>Results Continued...</h3>
            </div>
            <div class="row no-gutter">
                <h3 class="col h3-responsive">{{scaleResult.scale?.name}}</h3>
            </div>
            <div class="row no-gutter">   
                <div class="col-7 col-md-5" *ngIf="scaleResult?.range?.clientContent && !SkipContent" [innerHTML]="scaleResult?.range?.clientContent"></div>
                <div class="col-5 ml-auto text-center">
                    <div class="row pl-5">
                            <h4 class="h4-responsive col-10 ml-auto mr-auto">YOUR CATEGORY</h4>
                    </div>
                    <div class="row pl-5">
                            <h5 class='h5-responsive scale-name col-10 ml-auto mr-auto'>{{scaleResult.range?.displayName}}</h5>
                    </div>
                    <div class="row" *ngIf="!SkipGraph">
                        <app-scale-chart class="col" [show-ranges]="false" [scale-result]="scaleResult" [show-scale-name]="false"></app-scale-chart>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="!SkipTable">
                    <app-scale-questions-list  class="col-12" [Questions]="AssessmentResult.assessment.getQuestionsForScale(scaleResult.scale)"></app-scale-questions-list>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/reports/report-items/addo-scale-results/addo-scale-results.component.html